<div class="notifications-page">
  <div class="notifications-page__header">
    <div>
      <h1>Notificações</h1>
      <p>{{ totalRecords }} registro(s) | {{ unreadCount }} não lida(s) nesta página</p>
    </div>

    <app-button-menu
      theme="white"
      size="small"
      label="Marcar notificações"
      [disabled]="notifications.length === 0 || bulkBusy"
      [items]="bulkMenuItems" />
  </div>

  <div class="notifications-page__content">
    <div class="notifications-page__state notifications-page__state--loading" *ngIf="isLoadingPage">
      <app-cog-loading-spinner [size]="56"></app-cog-loading-spinner>
      <span>Carregando notificações...</span>
    </div>

    <div class="notifications-page__state" *ngIf="!isLoadingPage && notifications.length === 0">
      Nenhuma notificação encontrada.
    </div>

    <div
      role="button"
      tabindex="0"
      class="notifications-page__item"
      *ngFor="let notification of notifications"
      [hidden]="isLoadingPage"
      [class.notifications-page__item--read]="notification.isRead"
      (click)="openNotification(notification)"
      (keydown.enter)="openNotificationFromKeyboard($event, notification)"
      (keydown.space)="openNotificationFromKeyboard($event, notification)">
      <div class="notifications-page__item__content">
        <div class="notifications-page__item__title-row">
          <span class="notifications-page__item__title">{{
            getNotificationTitle(notification)
          }}</span>
          <span class="notifications-page__item__dot" *ngIf="!notification.isRead"></span>
        </div>

        <p class="notifications-page__item__message">{{ getNotificationMessage(notification) }}</p>

        <small class="notifications-page__item__time">
          {{ notification.createdAtUtc | date: 'dd/MM/yyyy HH:mm' }}
        </small>
      </div>
      <app-notification-read-toggle
        [isRead]="notification.isRead"
        [busy]="readBusyId === notification.id"
        (readToggled)="setNotificationRead(notification, $event)" />
    </div>
  </div>

  <div class="notifications-page__footer">
    <p-paginator
      [first]="(currentPage - 1) * pageSize"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[10, 20, 50]"
      (onPageChange)="onPageChange($event)">
    </p-paginator>
  </div>
</div>

<app-dialog
  #notificationTextDialog
  [key]="'notification-text-dialog-page'"
  [action]="'notification-text-dialog-page'"
  [headerTheme]="'simple'"
  [title]="notificationTextModalTitle"
  [hideDefaultFooter]="true"
  [maxWidth]="'720px'"
  [maxHeight]="'80vh'"
  (onClose)="closeNotificationTextDialog()">
  <div class="notification-text-modal">
    <div class="notification-text-modal__content" [innerHTML]="notificationTextModalHtml"></div>
  </div>
</app-dialog>
